import { create } from "zustand";

const useConfigEnv = create((set) => ({
    env: {},
    setEnv: (env: any) => set(() => ({ env: env })),
}));

export default useConfigEnv;
